import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'

import GlassDesignerTypes from '../types'
import { InventoryStockTypes } from '@/store/types'

/*
 * OrderItem
 * Represents an OrderItem (from server) that is used to keep details for OrderItems locally associated with the glass panels & order
 * Properties should match OrderItem server database model
 */
export default class OrderItem {
  constructor(itemData = {}) {
    this.id = itemData.id || (`temp-id-` + uuidv4())
    this.parentOrderItemId = itemData.parentOrderItemId || null
    this.stockType = itemData.stockType || InventoryStockTypes.glass
    this.isExternal = itemData.isExternal || false
    this.isProcessedItem = itemData.isProcessedItem || false
    this.isSplitSheetItem = itemData.isSplitSheetItem || false
    this.isEditorGeneratedItem = itemData.isEditorGeneratedItem || false

    this.isDeliveryItem = itemData.isDeliveryItem || false
    this.isMinInvoiceItem = itemData.isMinInvoiceItem || false
    this.isMinPriceItem = itemData.isMinPriceItem || false
    this.isMinPriceSingleItem = itemData.isMinPriceSingleItem || false
    this.requiresCustomerApproval = itemData.requiresCustomerApproval || false

    this.description = itemData.description || ''
    this.generatedDescription = itemData.generatedDescription || ''
    this.mark = itemData.mark || ''
    this.notes = itemData.notes || ''
    this.orderEditorNotes = itemData.orderEditorNotes || ''
    this.quantity = itemData.quantity || 0
    this.units = itemData.units || 0
    this.edgeworkFlagList = _.clone(itemData.edgeworkFlagList || [])
    this.grainDirection = itemData.grainDirection || null
    this.stockFaceSideUpType = itemData.stockFaceSideUpType || null

    this.isCancelled = itemData.isCancelled || false
    this.isCancelFeeItem = itemData.isCancelFeeItem || false

    this.unitPrice = itemData.unitPrice || 0
    this.unitPriceOverridden = !!itemData.unitPriceOverridden
    this.originalUnitPrice = itemData.originalUnitPrice || 0
    this.itemPrice = itemData.itemPrice || 0
    this.isMinChargeDisabled = itemData.isMinChargeDisabled || false
    this.isMinPriceItem = itemData.isMinPriceItem || false
    this.isMinPriceSingleItem = itemData.isMinPriceSingleItem || false
    this.isMinInvoiceItem = itemData.isMinInvoiceItem || false
    this.minChargeInvoice = itemData.minChargeInvoice || 0
    this.minChargePrice = itemData.minChargePrice || 0
    this.minChargeItemPrice = itemData.minChargeItemPrice || 0
    this.minChargeQuantity = itemData.minChargeQuantity || 0
    this.taxRatePercent = itemData.taxRatePercent || 0
    this.taxRateId = itemData.taxRateId || 0
    this.discountRate = itemData.discountRate || 0
    this.discountAmount = itemData.discountAmount || 0
    this.linePrice = itemData.linePrice || 0

    this.groupMinChargePrice = itemData.groupMinChargePrice || 0
    this.groupTotalItemPrice = itemData.groupTotalItemPrice || 0

    this.glassHeight = itemData.glassHeight || 0
    this.glassWidth = itemData.glassWidth || 0

    this.unitsNotice = itemData.unitsNotice || ''
    this.priceNotice = itemData.priceNotice || ''
    this.priceError = itemData.priceError || ''
    this.productionError = itemData.productionError || ''
    this.productionStockError = itemData.productionStockError || ''
    this.productionConfigError = itemData.productionConfigError || ''
    this.productionEditorError = itemData.productionEditorError || ''

    // NCR details
    this.ncrRequestReason = itemData.ncrRequestReason || ''
    this.ncrRejectionNote = itemData.ncrRejectionNote || ''
    this.ncrAccountsChargeNote = itemData.ncrAccountsChargeNote || ''
    this.ncrLabelList = itemData.ncrLabelList || []
    this.ncrUploadFileList = itemData.ncrUploadFileList || []

    // Stored info
    this.thickness = itemData.thickness || 0
    this.stock = _.cloneDeep(itemData.stock || {})
    this.stockPriceGroup = _.cloneDeep(itemData.stockPriceGroup || {})
    this.servicePriceRange = _.cloneDeep(itemData.servicePriceRange || {})
    this.glassLevel = _.cloneDeep(itemData.glassLevel || {})

    this.stockId = itemData.stockId || null
    this.stockPriceGroupId = itemData.stockPriceGroupId || null
    this.glassLevelId = itemData.glassLevelId || null

    // Editor shape info
    this.editorData = _.cloneDeep(itemData.editorData || {})
    _.defaults(this.editorData, {
      editorType: null,
      glassShapeId: null
    })

    this.shapeData = _.cloneDeep(itemData.shapeData || {})
    this.shapeDataHash = itemData.shapeDataHash || null
   
  }


  // Serialize/Deserialize to/from a JSON object
  serialize() {
    var outputData = {}

    return outputData
  }
  deserialize(object) {

  }


  /**
   * Clone the order item
   */
  clone() {
    var itemCopy = new OrderItem()
    let data = this.serialize()

    itemCopy.deserialize(data)
    return itemCopy
  }
}
